module.exports = __webpack_public_path__ + "img/loading.5f60eb80.gif";